document.addEventListener('DOMContentLoaded', function() {
  var removeButton = document.querySelector('a.product__remove');

  console.log('Remove button found...');
  if (removeButton) {
    removeButton.addEventListener('click', function(e) {
      console.log('using fetch...');
      e.preventDefault();
      fetch(this.href, { method: 'GET' })
        .then(response => {
          if (response.ok) {
            return response.text();  // or response.json() if the response is JSON
          } else {
            throw new Error('Network response was not ok.');
          }
        })
        .then(() => {
          window.location.href = '/products/' + productHandle;
        })
        .catch(error => console.error('Fetch error:', error));
    });
  }
});

window.addEventListener('pageshow', function(event) {
  if (event.persisted || (window.performance && window.performance.getEntriesByType("navigation")[0].type === 'back_forward')) {
    window.location.reload();
  }
});